export const LOGIN_FORM = 'loginForm'
export const AUTH = 'auth'
